<div class="left-content">
  <app-nav-dot-menu [menu]="menuData" (menuSelected)="onNavItemSelected($event)" />
</div>
<div class="full-width-content">
  <app-nav-dot-tab *ngFor="let tab of menuData" [key]="tab.value" [label]="tab.name" [selected]="tab.selected" (tabSelected)="onNavItemSelected($event)" />
</div>
